var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-sidenav-frame"},[_c('nuxt-link',{attrs:{"to":""}},[_c('span',{staticClass:"en"},[_vm._v("Prev Post")])]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":""}},[_c('span',{staticClass:"en"},[_vm._v("Next Post")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }